import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import ContactFormField from './ContactFormField';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        'service_2rn0eub', // Reemplaza con tu Service ID de EmailJS
        'template_3lue1uq', // Reemplaza con tu Template ID de EmailJS
        formData,
        '1GjyOakpcjuczsyf8' // Reemplaza con tu Public Key de EmailJS
      )
      .then(
        () => {
          setStatus('success');
          setFormData({ name: '', email: '', message: '' }); // Limpia el formulario
        },
        () => {
          setStatus('error');
        }
      );
  };

  return (
    <form className="contact__form" onSubmit={handleSubmit}>
      <ContactFormField
        label="Name"
        type="text"
        name="name"
        id="name"
        placeholder="Enter Your Name"
        value={formData.name}
        onChange={handleChange}
      />
      <ContactFormField
        label="Email"
        type="email"
        name="email"
        id="email"
        placeholder="Enter Your Email"
        value={formData.email}
        onChange={handleChange}
      />
      <ContactFormField
        label="Message"
        name="message"
        id="message"
        placeholder="Enter Your Message"
        isTextArea={true}
        value={formData.message}
        onChange={handleChange}
      />
      <button type="submit" className="btn btn--theme contact__btn">
        Submit
      </button>
      {status === 'success' && <p className="contact-success">Message sent successfully!</p>}
      {status === 'error' && <p className="contact-error">Failed to send the message. Please try again.</p>}
    </form>
  );
};

export default ContactForm;